import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL, USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import deviceInfoAxios from '../../../../utils/axios/deviceInfo.axios';


const tryToFetchHistoryChats = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/users/chat-history`);
};

const tryToFetchHistoryChatsRebecca = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/chatbox/topics?type=HISTORY&dashboard=rebecca`;
    return deviceInfoAxios.get<any>(url);
};

const tryToFetchSingleChat = (topicId: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/chatbox/chat?topic=${topicId}`);
};

const tryToAddActionForChat = (id: string, data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/chatbox/messages/${id}/reaction`, data);
};

export const HistoryChatsService = {
    tryToFetchHistoryChats,
    tryToFetchHistoryChatsRebecca,
    tryToFetchSingleChat,
    tryToAddActionForChat
};